import React, { useState, useEffect, useMemo } from 'react';
import Grid from "@mui/material/Grid2";
import { IconButton } from "@mui/material";
import { TextField, Button } from "@mui/material";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { MESSAGE_ERRORS } from "../../common/constants/scheduleModule/messagesConstants.js";
import { MESSAGE_STRINGS, MESSAGE_KEYS } from "../../common/constants/scheduleModule/messagesConstants.js";
import { SIZES, VARIANTS, STRINGS, BUTTON_COLORS, AUTO_COMPLETE, SORT_ORDERS } from "../../common/constants/commonConstants.js";
import { getComparator, handleSort } from "../../hooks/useTable.js";
import { getupcomingMessagesInfo } from "../../services/scheduleModule/scheduledataServices.js";
import UpcomingScheduleMessagesTable from "./UpcomingScheduleMessagesTable.jsx";

const UpcomingScheduleMessages = ({ scheduleID, scheduleDataId, campaignName, scheduleName, onBack }) => {
	const [page, setPage] = useState(0);
	const [inactive, setInactive] = useState(false);
	const [messageLogs, setMessageLogs] = useState([]);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [searchMessage, setSearchMessage] = useState("");
	const [order, setOrder] = useState(SORT_ORDERS.ASCENDING);
	const [loadingMessages, setLoadingMessages] = useState(true);
	const [orderBy, setOrderBy] = useState(MESSAGE_KEYS.MESSAGE_NAME);

	useEffect(() => {
		fetchMessages();
	}, [inactive]);

	useEffect(() => {
		setPage(0);
	}, [searchMessage]);

	const fetchMessages = async () => {
		try {
			setLoadingMessages(true);
			setMessageLogs(await getupcomingMessagesInfo({ scheduleID, scheduleDataId, inactive }));
		} catch (error) {
			console.error(MESSAGE_ERRORS.FETCH_MESSAGES_ERROR, error);
		} finally {
			setLoadingMessages(false);
		}
	};

	const { messagesToDisplay, filteredMessagesLength } = useMemo(() => {
		const filteredMessages = messageLogs
			.filter((messageLog) => {
				const search = searchMessage.toLowerCase();
				return (
					messageLog.customer?.toLowerCase().includes(search) ||
					messageLog.campaignSchedulemsg?.toLowerCase().includes(search)
				);
			});
		return {
			messagesToDisplay: filteredMessages
				.sort(getComparator(order, orderBy))
				.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
			filteredMessagesLength: filteredMessages.length,
		};
	}, [messageLogs, searchMessage, order, orderBy, page, rowsPerPage]);

	const handleRequestSort = (property) => {
		handleSort(order, orderBy, property, setOrder, setOrderBy);
	};

	const handleFilterClick = (isInactive) => {
        setInactive(isInactive ? true : false);
        setPage(0);
    };

	return (
		<>
			<IconButton variant="outlined" color="secondary" onClick={onBack}>
				<>
					<ArrowCircleLeftOutlinedIcon />
					<span style={{ marginLeft: 10, fontSize: 16 }}>{campaignName} / {scheduleName}</span>
				</>
			</IconButton>
			<Grid container spacing={2} sx={{ mb: 2 }}>
				<Grid size={SIZES.GROW}>
					<TextField
						fullWidth
						size={SIZES.SMALL}
						value={searchMessage}
						variant={VARIANTS.OUTLINED}
						autoComplete={AUTO_COMPLETE.OFF}
						label={MESSAGE_STRINGS.SEARCH_MESSAGES}
						onChange={e => setSearchMessage(e.target.value)}
					/>
				</Grid>
				<Grid size={SIZES.AUTO} display="flex" gap={1}>
					<Button
						variant={inactive ? VARIANTS.OUTLINED : VARIANTS.CONTAINED}
						color={BUTTON_COLORS.PRIMARY}
						onClick={() => handleFilterClick(false)}
					>
						{MESSAGE_STRINGS.UPCOMING}
					</Button>
					<Button
						variant={!inactive ? VARIANTS.OUTLINED : VARIANTS.CONTAINED}
						color={BUTTON_COLORS.PRIMARY}
						onClick={() => handleFilterClick(true)}
					>
						{STRINGS.INACTIVE}
					</Button>
				</Grid>
			</Grid>
			<UpcomingScheduleMessagesTable
				page={page}
				order={order}
				setPage={setPage}
				orderBy={orderBy}
				rowsPerPage={rowsPerPage}
				isLoading={loadingMessages}
				messages={messagesToDisplay}
				fetchMessages={fetchMessages}
				setRowsPerPage={setRowsPerPage}
				handleRequestSort={handleRequestSort}
				filteredMessagesLength={filteredMessagesLength}
			/>
		</>
	);
};

export default UpcomingScheduleMessages;